import context from './src/context';
import useConfig from './src/useConfig';

// Individual Exports
export const {
    CoreProvider,
    CoreConsumer,
    CoreContext,
} = context;

export { useConfig };

// Default
export default {
    ...context,
    useConfig
};
